import {createView, view} from '@sail/ui';
import type {View} from '@sail/engine';

export const TopBar: React.FC<View.IntrinsicElement<'div'>> = createView(
  (props) => {
    return (
      <view.div
        {...props}
        css={{
          minHeight: 'space.500',
          paddingX: 'medium',
          paddingY: 'medium',
          border: '1px solid',
          borderColor: 'border',
          backgroundColor: 'surface',
          borderTopWidth: '0',
          borderLeftWidth: '0',
          borderRightWidth: '0',
          boxShadow: 'medium',
        }}
      />
    );
  },
);
